var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',[_c('nuxt-link',{attrs:{"to":_vm.url}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }